function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#EBEDEF",
  cx: 7.5,
  cy: 7.5,
  r: 7.5
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#666",
  strokeWidth: 0.99,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M10.385 4.068L7.5 6.376 4.616 4.068M10.385 11.089L7.5 8.781 4.616 11.09"
}));

var SvgBtnUnfold = function SvgBtnUnfold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15
  }, props), _ref);
};

export default SvgBtnUnfold;